import React from 'react';

const Hero = () => {
    return (
        <section id="inicio" className="hero-pattern min-h-screen flex items-center relative pt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-20">
                <div className="max-w-3xl">
                    <span className="inline-block py-1 px-3 rounded-full bg-brand-500/20 text-brand-400 font-semibold text-sm mb-6 border border-brand-500/30 backdrop-blur-sm">
                        El Sistema Operativo de tu Taller
                    </span>
                    <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
                        Gestiona tu taller con <span className="text-brand-500">inteligencia real</span>
                    </h1>
                    <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl leading-relaxed">
                        Inventario en tiempo real, agendamiento automático, historial clínico del vehículo y facturación rápida. Todo en una sola plataforma diseñada para talleres que quieren crecer sin perder el control.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4">
                        <a href="#contacto" className="bg-brand-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-brand-500 transition-all text-center flex items-center justify-center gap-2 shadow-lg shadow-brand-600/30 group">
                            Registrar mi Taller <i data-lucide="arrow-right" className="w-5 h-5 group-hover:translate-x-1 transition-transform"></i>
                        </a>
                        <a href="#servicios" className="bg-white/10 text-white backdrop-blur-md border border-white/20 px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all text-center">
                            Ver Funciones
                        </a>
                    </div>

                    {/* Quick Stats */}
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-16 pt-8 border-t border-white/10">
                        <div>
                            <h4 className="text-3xl font-bold text-white mb-1">Cero</h4>
                            <p className="text-gray-400 text-sm">Pérdidas por repuestos no cobrados</p>
                        </div>
                        <div>
                            <h4 className="text-3xl font-bold text-white mb-1">100%</h4>
                            <p className="text-gray-400 text-sm">Control de stock en tiempo real</p>
                        </div>
                        <div className="hidden md:block">
                            <h4 className="text-3xl font-bold text-white mb-1">1 clic</h4>
                            <p className="text-gray-400 text-sm">De cotización a factura</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
